import { render, staticRenderFns } from "./DetailsComponent.vue?vue&type=template&id=ad2f0a72&scoped=true&"
import script from "./DetailsComponent.vue?vue&type=script&lang=js&"
export * from "./DetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailsComponent.vue?vue&type=style&index=0&id=ad2f0a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2f0a72",
  null
  
)

export default component.exports